// MoonPay Supported Currencies and Exchange Rates
// Based on MoonPay's 37 supported currencies

export const CURRENCIES = [
  { code: 'USD', name: 'US Dollar', symbol: '$', flag: '\ud83c\uddfa\ud83c\uddf8', region: 'North America', rate: 1.00 },
  { code: 'EUR', name: 'Euro', symbol: '\u20ac', flag: '\ud83c\uddea\ud83c\uddfa', region: 'Europe', rate: 0.92 },
  { code: 'GBP', name: 'Pound Sterling', symbol: '\u00a3', flag: '\ud83c\uddec\ud83c\udde7', region: 'Europe', rate: 0.79 },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', flag: '\ud83c\udde6\ud83c\uddfa', region: 'Oceania', rate: 1.52 },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', flag: '\ud83c\udde8\ud83c\udde6', region: 'North America', rate: 1.35 },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', flag: '\ud83c\udde8\ud83c\udded', region: 'Europe', rate: 0.88 },
  { code: 'BGN', name: 'Bulgarian Lev', symbol: '\u043b\u0432', flag: '\ud83c\udde7\ud83c\uddec', region: 'Europe', rate: 1.80 },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', flag: '\ud83c\udde7\ud83c\uddf7', region: 'South America', rate: 4.95 },
  { code: 'COP', name: 'Colombian Peso', symbol: '$', flag: '\ud83c\udde8\ud83c\uddf4', region: 'South America', rate: 3950.0 },
  { code: 'CZK', name: 'Czech Koruna', symbol: 'K\u010d', flag: '\ud83c\udde8\ud83c\uddff', region: 'Europe', rate: 22.5 },
  { code: 'DKK', name: 'Danish Krone', symbol: 'kr', flag: '\ud83c\udde9\ud83c\uddf0', region: 'Europe', rate: 6.85 },
  { code: 'DOP', name: 'Dominican Peso', symbol: 'RD$', flag: '\ud83c\udde9\ud83c\uddf4', region: 'Caribbean', rate: 59.0 },
  { code: 'EGP', name: 'Egyptian Pound', symbol: '\u00a3', flag: '\ud83c\uddea\ud83c\uddec', region: 'Africa', rate: 49.0 },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', flag: '\ud83c\udded\ud83c\uddf0', region: 'Asia', rate: 7.80 },
  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', flag: '\ud83c\uddee\ud83c\udde9', region: 'Asia', rate: 15500.0 },
  { code: 'ILS', name: 'Israeli New Shekel', symbol: '\u20aa', flag: '\ud83c\uddee\ud83c\uddf1', region: 'Middle East', rate: 3.65 },
  { code: 'JOD', name: 'Jordanian Dinar', symbol: 'JD', flag: '\ud83c\uddef\ud83c\uddf4', region: 'Middle East', rate: 0.71 },
  { code: 'KES', name: 'Kenyan Shilling', symbol: 'KSh', flag: '\ud83c\uddf0\ud83c\uddea', region: 'Africa', rate: 129.0 },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'KD', flag: '\ud83c\uddf0\ud83c\uddfc', region: 'Middle East', rate: 0.31 },
  { code: 'LKR', name: 'Sri Lankan Rupee', symbol: 'Rs', flag: '\ud83c\uddf1\ud83c\uddf0', region: 'Asia', rate: 326.0 },
  { code: 'MXN', name: 'Mexican Peso', symbol: '$', flag: '\ud83c\uddf2\ud83c\uddfd', region: 'North America', rate: 17.0 },
  { code: 'NGN', name: 'Nigerian Naira', symbol: '\u20a6', flag: '\ud83c\uddf3\ud83c\uddec', region: 'Africa', rate: 920.0 },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', flag: '\ud83c\uddf3\ud83c\uddf4', region: 'Europe', rate: 10.5 },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', flag: '\ud83c\uddf3\ud83c\uddff', region: 'Oceania', rate: 1.62 },
  { code: 'OMR', name: 'Omani Rial', symbol: 'OMR', flag: '\ud83c\uddf4\ud83c\uddf2', region: 'Middle East', rate: 0.38 },
  { code: 'PEN', name: 'Peruvian Sol', symbol: 'S/', flag: '\ud83c\uddf5\ud83c\uddea', region: 'South America', rate: 3.75 },
  { code: 'PLN', name: 'Polish Z\u0142oty', symbol: 'z\u0142', flag: '\ud83c\uddf5\ud83c\uddf1', region: 'Europe', rate: 4.02 },
  { code: 'RON', name: 'Romanian Leu', symbol: 'lei', flag: '\ud83c\uddf7\ud83c\uddf4', region: 'Europe', rate: 4.57 },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', flag: '\ud83c\uddf8\ud83c\uddea', region: 'Europe', rate: 10.4 },
  { code: 'THB', name: 'Thai Baht', symbol: '\u0e3f', flag: '\ud83c\uddf9\ud83c\udded', region: 'Asia', rate: 35.5 },
  { code: 'TRY', name: 'Turkish Lira', symbol: '\u20ba', flag: '\ud83c\uddf9\ud83c\uddf7', region: 'Middle East', rate: 34.0 },
  { code: 'TWD', name: 'Taiwan Dollar', symbol: 'NT$', flag: '\ud83c\uddf9\ud83c\uddfc', region: 'Asia', rate: 31.5 },
  { code: 'VND', name: 'Vietnamese Dong', symbol: '\u20ab', flag: '\ud83c\uddfb\ud83c\uddf3', region: 'Asia', rate: 24500.0 },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', flag: '\ud83c\uddff\ud83c\udde6', region: 'Africa', rate: 18.5 }
];

// MoonPay Fee Structure based on payment method
export const MOONPAY_FEES = {
  bankTransfer: {
    percentage: 1.0,
    minimumFee: 3.99,
    description: 'Bank Transfer (SEPA, ACH, FedWire)'
  },
  card: {
    percentage: 4.5,
    minimumFee: 3.99,
    description: 'Debit/Credit Cards, Apple Pay, Google Pay'
  },
  paypal: {
    percentage: 4.5,
    minimumFee: 3.99,
    description: 'PayPal'
  }
};

// RouteFlow AI Markup (configurable)
export const ROUTEFLOW_MARKUP = {
  bankTransfer: 2.5, // 2.5% markup on bank transfers
  card: 2.0,         // 2.0% markup on card payments
  paypal: 2.0        // 2.0% markup on PayPal
};

// Calculate total fee for customer
export const calculateTotalFee = (amount, paymentMethod = 'bankTransfer') => {
  const moonpayFee = MOONPAY_FEES[paymentMethod];
  const routeflowMarkup = ROUTEFLOW_MARKUP[paymentMethod];
  
  // Calculate MoonPay fee
  const moonpayFeeAmount = Math.max(
    (amount * moonpayFee.percentage) / 100,
    moonpayFee.minimumFee
  );
  
  // Calculate RouteFlow markup
  const routeflowFeeAmount = (amount * routeflowMarkup) / 100;
  
  // Total fee
  const totalFee = moonpayFeeAmount + routeflowFeeAmount;
  
  // Total percentage
  const totalPercentage = ((totalFee / amount) * 100).toFixed(2);
  
  return {
    moonpayFee: moonpayFeeAmount.toFixed(2),
    routeflowFee: routeflowFeeAmount.toFixed(2),
    totalFee: totalFee.toFixed(2),
    totalPercentage: totalPercentage,
    totalAmount: (amount + totalFee).toFixed(2)
  };
};

// Convert amount from one currency to another
export const convertCurrency = (amount, fromCurrency, toCurrency) => {
  const fromRate = CURRENCIES.find(c => c.code === fromCurrency)?.rate || 1;
  const toRate = CURRENCIES.find(c => c.code === toCurrency)?.rate || 1;
  
  // Convert to USD first, then to target currency
  const usdAmount = amount / fromRate;
  const convertedAmount = usdAmount * toRate;
  
  return convertedAmount.toFixed(2);
};

// Get currency by code
export const getCurrency = (code) => {
  return CURRENCIES.find(c => c.code === code);
};

// Get currencies by region
export const getCurrenciesByRegion = (region) => {
  if (region === 'all') return CURRENCIES;
  return CURRENCIES.filter(c => c.region === region);
};

// Get all regions
export const REGIONS = [
  'North America',
  'South America',
  'Europe',
  'Africa',
  'Middle East',
  'Asia',
  'Oceania',
  'Caribbean'
];

// Popular currency corridors
export const POPULAR_CORRIDORS = [
  { from: 'USD', to: 'MXN', label: 'US to Mexico' },
  { from: 'USD', to: 'NGN', label: 'US to Nigeria' },
  { from: 'USD', to: 'VND', label: 'US to Vietnam' },
  { from: 'EUR', to: 'TRY', label: 'Europe to Turkey' },
  { from: 'EUR', to: 'NGN', label: 'Europe to Nigeria' },
  { from: 'EUR', to: 'EGP', label: 'Europe to Egypt' },
  { from: 'GBP', to: 'NGN', label: 'UK to Nigeria' },
  { from: 'GBP', to: 'KES', label: 'UK to Kenya' },
  { from: 'CAD', to: 'VND', label: 'Canada to Vietnam' },
  { from: 'AUD', to: 'IDR', label: 'Australia to Indonesia' }
];

export default CURRENCIES;
